export const OBJECT_TYPES = [
    "AppUser",
    "WaterUser"
]

export const objectTypePipe = (value: string) => {
    switch (value) {
        case "AppUser":
            return "Người dùng hệ thống";
        case "WaterUser":
            return "Hợp đồng nước"
    }
}